__turbopack_context__.v({
  "Cont": "Related-module-sass-module__Bl7x8W__Cont",
  "Posts": "Related-module-sass-module__Bl7x8W__Posts",
  "Related": "Related-module-sass-module__Bl7x8W__Related",
});
